module.exports = require("@splunk/dashboard-visualizations/Punchcard");